module.exports = __webpack_public_path__ + "media/images/icon-explorer-67dd02025e8e42ed3e11bcdf58090c6d.svg";